import React from 'react';
import { Category } from '../../types';
import { CategoryCreateRequest, CategoryUpdateRequest } from '../../services/api/categoryService';
import CategoryForm from './CategoryForm';
import { TaskyDialog } from '../tasky';

interface CategoryFormModalProps {
  isOpen: boolean;
  category?: Category | null;
  onSubmit: (data: CategoryCreateRequest | CategoryUpdateRequest) => void;
  onClose: () => void;
  isLoading?: boolean;
}

const CategoryFormModal: React.FC<CategoryFormModalProps> = ({
  isOpen,
  category,
  onSubmit,
  onClose,
  isLoading = false
}) => {
  if (!isOpen) return null;

  return (
    <TaskyDialog
      open={isOpen}
      onClose={onClose}
      title={category ? 'カテゴリ編集' : 'カテゴリ新規作成'}
      size="lg"
    >
      <CategoryForm
        category={category}
        onSubmit={onSubmit}
        onCancel={onClose}
        isLoading={isLoading}
      />
    </TaskyDialog>
  );
};

export default CategoryFormModal;
